module.exports = __webpack_public_path__ + "static/bdd6e4cce95afbd229e070709dcbd428ec0679a177751b144b6e046491a5dcb0-1fe16b206d92dac68c7d593ce7a380e9.jpeg";